import { MutationHookOptions, useMutation } from '@apollo/client';

import { BULK_MOVE_TO_MUTATION } from '@frontend/app/queries';
import { BulkMoveToMutation, BulkMoveToMutationVariables } from '@frontend/app/queries/types/BulkMoveToMutation';

type IOptions = MutationHookOptions<BulkMoveToMutation, BulkMoveToMutationVariables>;

export const useBulkMoveToMutation = (options: IOptions = {}) => useMutation(BULK_MOVE_TO_MUTATION, options);
